export default "__VITE_ASSET__COuBEJXx__"